import { CreateIconArguments } from '##/icons/Icon/helpers';

import IconZoneOrangeSizeS from './IconZoneOrange_size_s';

const props: CreateIconArguments = {
  l: IconZoneOrangeSizeS,
  m: IconZoneOrangeSizeS,
  s: IconZoneOrangeSizeS,
  xs: IconZoneOrangeSizeS,
  name: 'IconZoneOrange',
  renderType: { l: 'use', m: 'use', s: 'use', xs: 'use' },
  color: 'multiple',
};

export default props;
